module.exports = __webpack_public_path__ + "img/98_4.953b967c.png";